export const initEditorialMentions = () => {
  const containers = document.getElementsByClassName('editorial-mentions__container');

  if (containers.length === 0) {
    return;
  }

  for (const container of containers) {
    const showMoreButton = container.getElementsByClassName(('editorial-mentions__show-more'));
    const listContainers = container.getElementsByClassName('editorial-mentions__expand-container');
    const buttonText = showMoreButton[0].getElementsByClassName('button__text');

    showMoreButton[0].addEventListener('click', expandShowMore(listContainers, buttonText));
  }
};

const expandShowMore = (_listContainers, _buttonText) => () => {
  const listContainers = _listContainers;
  const buttonText = _buttonText;

  if (listContainers[0].classList.contains('--show')) {
    Velocity(listContainers[0], 'slideUp').then(() => {
      listContainers[0].classList.remove('--show');
    });
    buttonText[0].innerHTML = 'Show More';
  } else {
    listContainers[0].classList.add('--show');
    Velocity(listContainers[0], 'slideDown');
    buttonText[0].innerHTML = 'Show Less';
  }
};
